import { createSlice } from "@reduxjs/toolkit";

// Slice для управления состоянием виджетов на дашбордах
export const EditWidjets = createSlice({
    name: "editWidjets",
    initialState: {
        editWidjets:false,
    },
    reducers: {
        onChangeEditWidjets: (state, {payload}) => {
            state.editWidjets = payload.editWidjets;
            return state;
        },
    },

});

export const { onChangeEditWidjets } = EditWidjets.actions;
export const EditWidjetsSelector = (state) => state.editWidjets;